import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import FormModal from 'components/FormModal';
import Fields from './fields';

const CreateUpdateLLMTestInputModal = ({
    modalId,
}: {
    modalId: string;
}) => {
    const { data, ...rest } = useConnectModal(modalId);
    const [, closeModal] = useOpenModal(modalId);
    return (
        <FormModal
            {...rest}
            onRequestClose={closeModal}
            initialValues={data as Record<string, unknown>}
            borderRadius="semi-square"
            size="small"
            title="Save input data"
            submitButtonLabel="Save"
            fields={Fields}
        />
    );
};

export default CreateUpdateLLMTestInputModal;
